import React from 'react';
import { Input } from 'reactstrap'
import './select.css';

export const Select = ({
  labelName,
  placeHolder,
  validationMessages,
  data = [],
  labelField,
  valueField,
  value,
  onChange,
  id }) => {

  let buildOptions = [];
  if (labelField && valueField)
    buildOptions = data.map((d, i) => <option key={i} value={d[valueField]}>{d[labelField]}</option>);
  else
    buildOptions = data.map((d, i) => <option key={i} value={d}>{d}</option>);
  return (
    <div className={validationMessages ? 'select-container form-group row has-error' : 'select-container form-group row'}>
      <label htmlFor="colFormLabel" className="col-12 col-md-3 col-form-label">{labelName}</label>
      <div className="col-12 col-md-9">
        <Input id={id} type="select" className={typeof value === 'undefined' || value === '' ? (validationMessages ? 'form-control error' : 'form-control place-holder') : 'form-control'} onChange={onChange} value={value}>
          <option value="">{placeHolder}</option>
          {buildOptions}
        </Input>
        {/* {buildValidationMessages} */}
      </div>
    </div>
  )
}






// WEBPACK FOOTER //
// ./src/components/Select/Select.js